<template>
  <div class="footer">
    <div class="container">
      <div class="footer-row">
        <a href="https://www.fr.ch/deef/sfp" target="blank">{{
          $t("service")
        }}</a>
        <div class="footer-editions">
          <a href="/2020">{{ $t("2020_edition") }}</a>
          <a href="/2021">{{ $t("2021_edition") }}</a>
          <a href="/2022">{{ $t("2022_edition") }}</a>
          <router-link
            v-if="edition !== '2023'"
            :to="{ name: 'edition-2023' }"
            >{{ $t("2023_edition") }}</router-link
          >
          <router-link
            v-if="edition !== '2024'"
            :to="{ name: 'edition-2024' }"
            >{{ $t("2024_edition") }}</router-link
          >
          <router-link
            v-if="edition !== '2025'"
            :to="{ name: 'edition-2025' }"
            >{{ $t("2025_edition") }}</router-link
          >
          <router-link
            v-if="edition !== '2026'"
            :to="{ name: 'edition-2026' }"
            >{{ $t("2026_edition") }}</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    edition: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.footer {
  margin-top: 30px;
  padding: 30px 0;
  border-top: solid 2px #000;

  a {
    color: #000;
  }
}

.footer-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;

  @media (min-width: 640px) {
    flex-direction: row;
  }
}

.footer-editions {
  display: flex;
  gap: 30px;
}
</style>
